import { defaultFilterBarConfig } from './filterBars';

import type { LayoutPageConfig } from './types';

export const mapPageConfig = {
  namespacesRequired: ['flowmap'],
  layout: {
    filterBar: defaultFilterBarConfig,
    noPaddedContent: true,
  },
} satisfies LayoutPageConfig;
